import {API_HOST} from 'config';
import {IKeyWordsList} from 'types';

import {api} from '../setup';

export const getSuggestions = (locale: string): Promise<IKeyWordsList> => {
  return api.get(`${API_HOST}/api/v2/index-search-autocomplete/data`, {
    headers: {['Accept-Language']: locale},
  });
};
